import { IShopCategory } from '~/src/api/content/shop/getShopCategories';
import { IShopItem, IShopProp } from '~/src/api/content/shop/getShopItems';

export enum EShopItemPropTypes {
    string = 'string',
    options = 'options',
}

interface IOption {
    key: string,
    value: string,
}

const getPropOptions = (category: IShopCategory | undefined, propName: string) => {
    const categoryProp = category?.props?.find(prop => prop.name === propName);

    if (!categoryProp || !categoryProp.options) {
        return [];
    }

    try {
        return JSON.parse(categoryProp.options) as IOption[];
    } catch {
        return [];
    }
};

const getStringValue = (value: string | string[] | undefined) => typeof value === 'string' ? value : '';

const getValueFromString = (asIs: boolean, value: string | string[] | undefined) => getStringValue(value);

const getValueFromOptions = (
    options: IOption[],
    value: string | string[] | undefined,
) => {
    if (typeof value !== 'string') {
        return '';
    }

    try {
        const optionKeys = JSON.parse(value);

        if (Array.isArray(optionKeys)) {
            const stringValue = optionKeys.reduce((acc: string[], key) => {
                const option = options.find(el => `${el.key}` === `${key}`);
                option ? acc.push(option.value) : acc;
                return acc;
            }, []);

            return stringValue.join(', ');
        }

        return '';
    } catch {
        return '';
    }
};

/* Рассчитывает значение value в зависимости от type для характеристик оборудования
* TODO эти расчеты должны выполняться на стороне бэка и возвращаться в поле props.value. EACI (expand api content imperfection)
*/
export const calculateEquipmentProps = ({ props, category }: IShopItem): IShopProp[] => {
    if (!props) {
        return [];
    }

    const newProps: IShopProp[] = props.map((prop) => {
        const { type: valueType, name: propName, asIs, value } = prop;

        let computedValue = '';

        if (valueType === EShopItemPropTypes.string) {
            computedValue = getValueFromString(!!asIs, value);
        }

        if (valueType === EShopItemPropTypes.options) {
            const options = getPropOptions(category, propName);
            computedValue = getValueFromOptions(options, value);
        }

        return {
            ...prop,
            value: computedValue,
        };
    });

    return newProps;
};
